import { Loader } from 'mol-ui';
import { accountActions } from 'core/Account';
import { config } from 'config';
import { useTranslation } from 'react-i18next';
import {
    Container,
    ErrorMessage,
    Link,
    StatusContainer,
    Subtitle,
    TextContainer,
    Title,
    Version
} from './styled';
import React, {
    useEffect
} from 'react';
import {
    useDispatch,
    useQuery,
    useSelector
} from 'hooks';
import {
    useHistory,
    useLocation
} from 'react-router-dom';
const { version } = config;

const LoginAccess = () => {
    
    const dispatch = useDispatch();

    const { t } = useTranslation();
    const { push } = useHistory();
    const { pathname, search } = useLocation();
    const { key, mode, redirect, role_selected } = useQuery();

    const { loginExternalStatus = 'validating' } = useSelector('account');

    useEffect(() => {
        try {
            const url = pathname + search;
            if (mode === 'ott') {
                const data = {
                    mode,
                    redirect,
                    role_selected: role_selected === 'true',
                    source: 'external',
                    token: key,
                    url
                };
                dispatch(accountActions.loginAccount(data));
            } else {
                push('/');
            }
        } catch (err) {
            push('/');
        }
    }, [pathname, push, search]);

    const goToBase = () => {
        dispatch(accountActions.setAccountLoginExternalStatus(''));
        push('/');
    };

    const displayVersion = `v${ version }`;

    return (
        <Container>
            <TextContainer>
                <Title>{ t('Ingresando a la plataforma') }</Title>
                {
                    loginExternalStatus !== 'error' &&
                    <Subtitle>{ t('Estamos validando sus datos y pronto será redirigido automáticamente') }</Subtitle>
                }
                {
                    loginExternalStatus === 'validating' &&
                    <StatusContainer>
                        <Loader active={ true } size={ 60 } type="dots" />
                    </StatusContainer>
                }
                {
                    loginExternalStatus === 'error' &&
                    <>
                        <StatusContainer>
                            <ErrorMessage>
                                { t('No pudimos verificar el usuario solicitado') }
                            </ErrorMessage>
                        </StatusContainer>
                        <Link onClick={ goToBase }>
                            { t('Volver al inicio') }
                        </Link>
                    </>
                }
            </TextContainer>
            <Version>
                { displayVersion }
            </Version>
        </Container>
    );
};

export default LoginAccess;
